import { CapitalActionEntryType } from 'further-types/lp/capital-action';
import { pluralize } from 'further-ui/utils';
import { UpdateCapitalActionFormValues } from './useCapitalActionForm';

const entryTypesTitles = {
  [CapitalActionEntryType.Expense]: 'Expense',
  [CapitalActionEntryType.Investment]: 'Investment',
  [CapitalActionEntryType.Fees]: 'Fees',
  [CapitalActionEntryType.GeneralCapitalCall]: 'General capital call',
  [CapitalActionEntryType.AdvanceSubscriptionPayment]:
    'Advance subscription payment',
  [CapitalActionEntryType.CapitalContributionCall]: 'Capital contribution call',
  [CapitalActionEntryType.CapitalRefund]: 'Return of capital',
  [CapitalActionEntryType.CapitalDistribution]: 'Distribution',
  [CapitalActionEntryType.Equalisation]: 'Equalisation',
  [CapitalActionEntryType.PartnerTransfer]: 'Partner transfer',
};

const noTransactionCountTypes = [
  CapitalActionEntryType.GeneralCapitalCall,
  CapitalActionEntryType.AdvanceSubscriptionPayment,
  CapitalActionEntryType.CapitalContributionCall,
  CapitalActionEntryType.CapitalRefund,
  CapitalActionEntryType.CapitalDistribution,
  CapitalActionEntryType.Equalisation,
  CapitalActionEntryType.PartnerTransfer,
];

export default function useGetEntryTitle() {
  const getEntryTitle = (
    entry: NonNullable<UpdateCapitalActionFormValues['entries']>[number],
    shortVersion = false,
  ) => {
    const hasTransactionCount = !noTransactionCountTypes.includes(
      entry.entryType,
    );

    if (shortVersion) {
      return hasTransactionCount
        ? `${entryTypesTitles[entry.entryType]} (${entry.actions.length})`
        : entryTypesTitles[entry.entryType];
    }

    if (!hasTransactionCount) {
      return `Capital call - ${entryTypesTitles[entry.entryType]}`;
    }

    return `Capital call - ${entryTypesTitles[entry.entryType]} (${
      entry.actions.length
    } ${pluralize('transaction', entry.actions.length)})`;
  };

  return getEntryTitle;
}
